import React, { useEffect, useState } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { AboutMe } from './components/AboutMe';
import { WhoIHelp } from './components/WhoIHelp';
import { Approach } from './components/Approach';
import { Services } from './components/Services';
import { Testimonials } from './components/Testimonials';
import { CTASection } from './components/CTASection';
import { Contact } from './components/Contact';
import { NewsletterSignup } from './components/NewsletterSignup';
import { Footer } from './components/Footer';
import { BrandAssets } from './components/BrandAssets';
export function App() {
  const [hash, setHash] = useState(typeof window !== 'undefined' ? window.location.hash : '');
  useEffect(() => {
    const handleHashChange = () => setHash(window.location.hash);
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  if (hash === '#brand-assets') {
    return <BrandAssets data-id="element-0" data-mp="3ij668fcdfvai" />;
  }
  return <div className="min-h-screen bg-offwhite-50 font-sans selection:bg-amber-500/30 selection:text-charcoal-950" data-id="element-1" data-mp="3ii4t85bsoyq5">
      <Navbar data-id="element-2" data-mp="3rc9ca2kot5v4" />
      <main data-id="element-3" data-mp="3rbrakqf99zft">
        <Hero data-id="element-4" data-mp="3rbzq6q2rjiup" />
        <AboutMe data-id="element-5" data-mp="3rdkg22e4udm8" />
        <WhoIHelp data-id="element-6" data-mp="3rd19fhtxnbni" />
        <Approach data-id="element-7" data-mp="3relw6la09qat" />
        <Services data-id="element-8" data-mp="5os92t1uy7l" />
        <Testimonials data-id="element-9" data-mp="682dxcgkib2" />
        <Contact data-id="element-10" data-mp="5gfdawxfswe" />
        <CTASection data-id="element-11" data-mp="82kl3wchwbg" />
        <NewsletterSignup data-id="element-12" data-mp="2zl3c5m4yv85u" />
      </main>
      <Footer data-id="element-13" data-mp="2zm4xqkjlzd1t" />
    </div>;
}